export const profileConstants = {
  GET_PROFILE: "GET_PROFILE",
  GET_PROFILE_SUCCESS: "GET_PROFILE_SUCCESS",
  GET_PROFILE_RANKINGS: "GET_PROFILE_RANKINGS",
  GET_PROFILE_RANKINGS_SUCCESS: "GET_PROFILE_RANKINGS_SUCCESS",
};
